import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchAnswerId'
})
export class SearchAnswerIdPipe implements PipeTransform {

  transform(list: any[], id: Number): any[] {
    return list.filter(item => item.m_answer_id == id);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/pipes/search-answer-id.pipe.ts